import { FilterHandler, useFilterState } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import ModalPickerFooter from '../../../components/form/modalPicker/ModalPickerFooter'
import ModalPickerHeader from '../../../components/form/modalPicker/ModalPickerHeader'
import Picker from '../../../packages/kiti/components/form/picker/Picker'
import ProfilesLoader, { useProfiles } from './_load/ProfilesLoader'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import SelectAllProfilesLink from '../SelectAllProfilesLink'
import SelectableListItem from '../../../packages/kiti/components/list/SelectableListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const Footer = ({ onClose, onChange, multiple, filter }) => {
  const { filter: filterState, search } = useFilterState()
  const { form, handleChangeIn } = useFormState()

  return (
    <ModalPickerFooter closeModal={onClose} onChange={onChange}>
      {!!multiple && (
        <SelectAllProfilesLink
          onSelect={handleChangeIn([])}
          value={form}
          useRawValues
          search={search}
          filter={{ ...filterState, ...filter }}
        />
      )}
    </ModalPickerFooter>
  )
}

const Content = props => {
  const options = useProfiles()
  const { form, handleChangeIn } = useFormState()

  return (
    <Picker
      Selector={SelectableListItem}
      options={options}
      value={form || []}
      onChange={handleChangeIn([])}
      idField="id"
      labelField="label"
      {...props}
    />
  )
}

const ProfilePickerModal = ({ open, onClose, value, onChange, level, ...props }) => {
  const { t } = useTranslation('profiles')

  return (
    <Modal width="32rem" noPadding open={open} onClose={() => onClose()} level={level}>
      <FilterHandler>
        <Form initialState={value || []}>
          <ModalPickerHeader title={t('selectProfiles')} useDeletedOption />
          <Line />

          <Scroll height="65vh">
            <ProfilesLoader>
              <Content closeModal={onClose} {...props} />
            </ProfilesLoader>
            <Separator weight={12} />
          </Scroll>

          <Line />
          <Footer onClose={onClose} onChange={onChange} {...props} />
        </Form>
      </FilterHandler>
    </Modal>
  )
}

export default ProfilePickerModal
